import React from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import PackagesSubFilePropertyTableData from "./PackagesSubFilePropertyTableData";

const PackagesSubFilePropertyModalData = ({
  show,
  title,
  bounds,
  setShow,
  onStart,
  disabled,
  onMouseOut,
  draggleRef,
  onMouseOver,
  subFileTableProperties,
  packageFileType
}) => {
  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={400}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={() => setShow(!show)}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <PackagesSubFilePropertyTableData
          subFileTableProperties={subFileTableProperties}
          packageFileType={packageFileType}
        />
      </Modal>
    </>
  );
};
export default PackagesSubFilePropertyModalData;
